import styles from './ConfirmUserCreationDialog.module.scss'

import Button from '@/components/Button'
import DialogWrapper from '@/components/Dialog'

interface UserFormData {
  email: string
  first_name: string
  last_name: string
}

interface ConfirmUserCreationDialogProps {
  isOpen: boolean
  formData: UserFormData | null
  isLoading: boolean
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmUserCreationDialog = ({
  isOpen,
  formData,
  isLoading,
  onConfirm,
  onCancel,
}: ConfirmUserCreationDialogProps) => {
  return (
    <DialogWrapper
      isOpen={isOpen}
      title="Confirm user creation"
      subtitle="You are about to create a new user with the following details. The user will receive an email to set their password."
      close={onCancel}
    >
      <div className={styles.dialogContent}>
        {formData && (
          <div className={styles.dialogDetailsSection}>
            <div className={styles.dialogNotificationDetails}>
              <p className={styles.dialogDetailItem}>
                <strong>Email:</strong>
                <span>{formData.email}</span>
              </p>
              <p className={styles.dialogDetailItem}>
                <strong>First Name:</strong>
                <span>{formData.first_name}</span>
              </p>
              <p className={styles.dialogDetailItem}>
                <strong>Last Name:</strong>
                <span>{formData.last_name}</span>
              </p>
            </div>
          </div>
        )}
        <div className={styles.dialogActions}>
          <Button title="Cancel" onClick={onCancel} type="light" />
          <Button title="Create User" onClick={onConfirm} type="dark" isLoading={isLoading} isDisabled={isLoading} />
        </div>
      </div>
    </DialogWrapper>
  )
}

export default ConfirmUserCreationDialog
